// extracted by mini-css-extract-plugin
export default {"app__wrapper":"app_app__wrapper__vVcjB","appHeader":"app_appHeader__NVEyi","content__wrapper":"app_content__wrapper__EOtXa","emptyText":"app_emptyText__LnRtq"};